module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewport",
    attrs: {
      "id": "app"
    }
  }, [_c('svg-symbols', {
    attrs: {
      "name": "icon"
    }
  }), _vm._v(" "), _c('svg-symbols', {
    attrs: {
      "name": "button"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [(_vm.ready) ? _c('div', {
    key: _vm.viewIndex,
    staticClass: "view"
  }, [_c('router-view', {
    staticClass: "view__content slide--inner"
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-427a9fc7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 632
// module chunks = 1